import { snakeToCamelCase } from './common';
import { ItemFilter } from '../../graphql/types';

export const parseVippedFiltersFromQuery = (query: unknown): ItemFilter => {
  if (!query || typeof query !== 'object') return {} as ItemFilter;

  const { id, nextInternalLocale, ...filterParams } = query;
  return Object.fromEntries(
    Object.entries(filterParams).map(([key, value]) => {
      const newKey = key.replace(/q\[([^\]]*)\]|\[\]/g, '$1');
      const newValue =
        !Number.isNaN(+value) || Array.isArray(value)
          ? value
          : value === 'true';

      return [
        snakeToCamelCase(newKey),
        newKey === 'building_type' ? value : newValue
      ];
    })
  ) as ItemFilter;
};
